import GoogleTagManager from '@redux-beacon/google-tag-manager';
import { createMetaReducer, createMiddleware } from 'redux-beacon';
import { accountEventsMap } from './events/account';
import { acEventsMap } from './events/activecampaign';
import { budgetEventsMap } from './events/budget';
import { cartEventsMap } from './events/cart';
import { checkoutEventsMap } from './events/checkout';
import { downloadsEventsMap } from './events/downloads';
import { impressionsEventsMap } from './events/impressions';
import { licensingEventsMap } from './events/licensing';
import { searchEventsMap } from './events/search';

const gtm = GoogleTagManager();

export const eventsMap = {
  ...licensingEventsMap,
  ...accountEventsMap,
  ...cartEventsMap,
  ...checkoutEventsMap,
  ...acEventsMap,
  ...downloadsEventsMap,
  ...impressionsEventsMap,
  ...searchEventsMap,
  ...budgetEventsMap,
};

export const gtmMiddleware = createMiddleware(eventsMap, gtm);
export const gtmMetaReducer = createMetaReducer(eventsMap, gtm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/gtm.ts